import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { emitDataChanged } from '@/lib/dataEvents';
import { deleteCV } from '@/services/cv';

export function useDeleteCV() {
  const { t } = useTranslation();
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const deleteCVById = async (cvId: string, onSuccess?: () => void) => {
    try {
      setDeletingId(cvId);
      await deleteCV(cvId);
      emitDataChanged('cvs-changed');
      toast.success(t('dashboard.cvList.delete.success'));
      onSuccess?.();
    } catch (err) {
      console.error('Failed to delete CV:', err);
      toast.error(t('dashboard.cvList.delete.error'));
    } finally {
      setDeletingId(null);
    }
  };

  return { deleteCVById, deletingId, isDeleting: deletingId !== null };
}
